export default __webpack_public_path__ + "static/media/photo--lg--92.bdd8f7f3.jpg";